// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14JZB","left":"styles_left__2iphs"};